import { Controller } from "@hotwired/stimulus"

// Страница лекала: 3 модалки (новый размер / изменить / удалить), чипы размера + валидация дублей,
// SVG-дропзона. Открытие/закрытие — toggle hidden/flex у соответствующего оверлея.
export default class extends Controller {
  static targets = ["newSizeModal", "editModal", "deleteModal", "sizeInput", "submitNew", "sizeError", "fileName", "fileInput", "clearFile"]
  static values = { taken: Array }

  openNewSize() { this._open(this.newSizeModalTarget); this.validateSize() }
  openEdit() { this._open(this.editModalTarget) }
  openDelete() { this._open(this.deleteModalTarget) }
  close(e) { for (const m of [this.newSizeModalTarget, this.editModalTarget, this.deleteModalTarget]) if (m) this._hide(m) }
  backdrop(e) { if (e.target === e.currentTarget) this._hide(e.currentTarget) }
  _open(m) { m.classList.remove("hidden"); m.classList.add("flex"); this._esc = (e) => { if (e.key === "Escape") this.close() }; document.addEventListener("keydown", this._esc) }
  _hide(m) { m.classList.add("hidden"); m.classList.remove("flex"); if (this._esc) document.removeEventListener("keydown", this._esc) }

  pickChip(e) { this.sizeInputTarget.value = e.currentTarget.dataset.size; this.validateSize() }

  validateSize() {
    const v = this.sizeInputTarget.value.trim()
    const dup = v !== "" && this.takenValue.includes(v.toLowerCase())
    if (this.hasSizeErrorTarget) this.sizeErrorTarget.hidden = !dup
    if (this.hasSubmitNewTarget) this.submitNewTarget.disabled = v === "" || dup
  }

  chooseFile() { this.fileInputTarget.click() }
  dropFile(e) { e.preventDefault(); const f = e.dataTransfer?.files?.[0]; if (f) { this.fileInputTarget.files = e.dataTransfer.files; this.showFile(f.name) } }
  onFile() { const f = this.fileInputTarget.files?.[0]; if (f) this.showFile(f.name) }
  showFile(name) { if (this.hasFileNameTarget) this.fileNameTarget.textContent = name; if (this.hasClearFileTarget) this.clearFileTarget.classList.remove("hidden") }
  clearFile(e) { e.preventDefault(); e.stopPropagation(); if (this.hasFileInputTarget) this.fileInputTarget.value = ""; if (this.hasFileNameTarget) this.fileNameTarget.textContent = ""; if (this.hasClearFileTarget) this.clearFileTarget.classList.add("hidden") }
  allowDrop(e) { e.preventDefault() }
}
